module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer font-size-12px-color noPrint"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-9"
  }, [_vm._v("\n        2022 © SGS DO BRASIL. All rights reserved.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-3"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('version')) + " - 1.17.03\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-487a2e3f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/footer/Footer.vue
// module id = 922
// module chunks = 2